import { render, staticRenderFns } from "./NoContentView.vue?vue&type=template&id=47805da0&scoped=true&"
import script from "./NoContentView.vue?vue&type=script&lang=js&"
export * from "./NoContentView.vue?vue&type=script&lang=js&"
import style0 from "./NoContentView.vue?vue&type=style&index=0&id=47805da0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47805da0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFabTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSlideXTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VBtn,VCol,VContainer,VFabTransition,VIcon,VRow,VSlideXTransition})
